import React from "react";
import { useState } from "react";
import { convertArrayToCSV } from "convert-array-to-csv";
import { saveAs } from "file-saver";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import "../Dashboard/Dashboard.css";
import Select from "react-select";
import { toast } from "react-toastify";
import { useEffect } from "react";
import moment from "moment";
import { useSelector } from "react-redux/es/exports";
import { AskpageNumber } from "../Model/AskpageNumber";
import Pagination from "../../utils/Pagination";
import axiosinstances from "../../Helper/useAxios";
import { ShowAllDetails } from "../Model/ShowAllDetails";
import { v4 as uuid } from "uuid";
// import { BsArrowClockwise } from "react-icons/bs";
import {
  allnumeric,
  fetchStatus,
  isSuperAdmin,
  isUserAdmin,
  requestLoading,
  stylesofStype,
  stylesofStypeNew,
} from "../../utils/comman/Common";
import { useNavigate } from "react-router-dom";

import AllRechagePlan from "./AllRechagePlan";
import { MOBILE, REQID, TXNID, setpageContent } from "../../utils/Constant";
import StatusDetails from "../../utils/comman/statusDetails";
let ruppysymble = "\u20B9";
const getDateAndTime = () => {
  return new Date().toISOString().slice(0, 19).replace("T", " ");
};
const MobileRecharge = () => {
  var flexWidth = window.innerWidth;

  const operatorList = process.env.REACT_APP_OPERATOR;
  const [userId, setUserId] = useState("");
  var allOperatorList = JSON.parse(operatorList);
  const navigate = useNavigate();
  const requesterId = useSelector(
    (state) => state.selectedretailerReqesterReducer.requesterId
  );
  const currentDate = moment().format("YYYY-MM-DD");
  const nextDate = moment().add(1, "day").format("YYYY-MM-DD");

  const [axiosInstance] = axiosinstances();
  const selectedId = useSelector((state) => state.selectedRetailerReducer.id);
  //console.log("selectedId", selectedId);
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const [statusOption, setStatusOption] = useState([
    { value: "SUCCESS", label: "SUCCESS" },
    { value: "ACCEPTED", label: "ACCEPTED" },
    { value: "PENDING", label: "PENDING" },
    { value: "INTERNAL_FAILURE", label: "INTERNAL_FAILURE" },
    { value: "PROCESSING", label: "PROCESSING" },
    { value: "HUNG", label: "HUNG" },
    { value: "FAILED", label: "FAILED" },
    { value: "AUTO_REVERSED", label: "AUTO_REVERSED" },
    { value: "MANUALLY_REVERSED", label: "MANUALLY_REVERSED" },
    { value: "SUCCESS_TO_FAILED", label: "SUCCESS_TO_FAILED" },
  ]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [isExportable, setIsExportable] = useState(false);
  const [finalSelectedStatus, setFinalSelectedStatus] = useState();
  const [showModal, setShowModel] = useState(false);
  const [firstSelectedPage, setFirstSelectedPage] = useState();
  const [secondSelectedPage, setSecondSelectedPage] = useState();
  const [search, setsearch] = useState("");
  const [searchTyping, setSearchTyping] = useState(false);
  const [formDate, setFormDate] = useState(currentDate);
  const [toDate, setToDate] = useState(currentDate);
  const [updatedFormDate, setUpdatedFormDate] = useState("");
  const [updatedToDate, setUpdatedToDate] = useState("");
  const [selectOption, setSelectOption] = useState("");
  const [pageStart, setpageStart] = useState(0);
  const [pagelimit, setPagelimit] = useState(0);
  const [customPage, setCustomPage] = useState("");
  const [paginationDetails, setPaginationDetails] = useState({
    currentPage: 1,
    postsPerPage: 20,
    totalPost: 0,
    totalPages: 0,
  });
  const [searched, setSearched] = useState({
    name: "",
    typing: false,
    typingTimeout: 0,
  });

  const [table, settable] = useState([]);
  const [backupTableData, setBackupTableData] = useState([]);
  const [rechargeTable, setRechargeTable] = useState([]);
  const [isclearClicked, setIsclearClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [isDataRechargeLoaded, setIsDataRechargeLoaded] = useState(false);
  const [categoryCode, setCategoryCode] = useState([
    { value: "amit", label: "Amit" },
  ]);
  const [selectedOperator, setSelectedOperator] = useState("");
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedSatate] = useState("");
  const [transactionStatuswithAmount, setTransactionStatuswithAmount] =
    useState([]);
  const [allPlans, setAllPlans] = useState({});
  const [allAvailablePlaneOption, setAllAvailablePlaneOption] = useState([]);
  const [selectedPlanes, setSelectedPlanes] = useState("");
  const [isnewProductAdded, setIsNewProductAdded] = useState(false);
  const [selectedDataToShow, setSelectedDataToShow] = useState({});
  const [showModalDetails, setShowModelDetails] = useState(false);
  const [selectedEditPlan, setSelectedEditPlan] = useState("");
  const [searchedBy, setSearchedBy] = useState();
  const [searchedByItem, setSearchedByItem] = useState([MOBILE, REQID, TXNID]);
  const [searchedByItemShow, setSearchedByItemShow] = useState(true);
  const [changedSearchMode, setChangedSearchMode] = useState(true);
  const intialvalues = {
    header: {
      "client-id": id, // client id will admin id
      role: "ROLE_RETAILER_FINXPAY",
      msgType: "ORDER_HISTORY",
      channel: "ADMIN",
      requesterId: requesterId,
      time: new Date(),
    },
    operator: "",
    circle: "",
    planType: "",
    plans: [
      {
        rs: "",
        desc: "",
        validity: "",
        last_update: getDateAndTime(),
      },
    ],
  };
  const [productDetails, setProductDetails] = useState(intialvalues);

  const getPlans = async () => {
    setIsDataRechargeLoaded(true);
    setsearch("");
    setStates([]);
    setAllPlans({});
    const response = await axiosInstance
      .post(
        `/api/v1/catalog/mobile/get-plan`,
        {
          header: {
            "client-id": id, // client id will admin id
            role: "ROLE_RETAILER_FINXPAY",
            msgType: "ORDER_HISTORY",
            channel: "ADMIN",
            requesterId: requesterId,
            time: new Date(),
          },
          mobile: "",
          operator: selectedOperator,
          circle: "ALL",
        },
        {
          headers: {
            Authorization: `Bearer ${e}`,
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
          },
        }
      )
      .then((res) => {
        setIsDataRechargeLoaded(false);
        setAllPlans(res.data.plans);
        const stateNames = Object.keys(res.data.plans);
        if (Array.isArray(stateNames)) {
          const stateListWithLable = stateNames.map((val) => ({
            value: val,
            label: val,
          }));
          setStates(stateListWithLable);
        }
      })
      .catch((err) => {
        setIsDataRechargeLoaded(false);
      });
  };
  useEffect(() => {
    if (selectedOperator !== "") {
      getPlans();
    }
  }, [selectedOperator]);

  useEffect(() => {
    setSearchedByItemShow(true);
  }, [search]);
  useEffect(() => {
    const callApiindelay = async (url) => {
      const callingsearchapi = await searchapidata(id, url);
      settable(() => callingsearchapi.orders);
    };
    if (search.length > 2) {
      if (searchedBy == MOBILE) {
        let url = `/api/v1/proxy/mobile/order/search/mobile/${search}`;
        if (
          requesterId !== undefined &&
          requesterId !== null &&
          !isSuperAdmin(id) &&
          isUserAdmin(id)
        ) {
          url = url + `/${requesterId}`;
        } else if (
          requesterId !== undefined &&
          requesterId !== null &&
          !isSuperAdmin(id) &&
          !isUserAdmin(id)
        ) {
          url = url + `/${id}`;
        }
        callApiindelay(url);
      } else if (searchedBy == REQID) {
        let url = `/api/v1/proxy/mobile/order/search/request-id/${search}`;
        if (
          requesterId !== undefined &&
          requesterId !== null &&
          !isSuperAdmin(id) &&
          isUserAdmin(id)
        ) {
          url = url + `/${requesterId}`;
        } else if (
          requesterId !== undefined &&
          requesterId !== null &&
          !isSuperAdmin(id) &&
          !isUserAdmin(id)
        ) {
          url = url + `/${id}`;
        }
        callApiindelay(url);
        setChangedSearchMode(false);
      } else if (searchedBy == TXNID) {
        const url = `/api/v1/proxy/mobile/order/search/${search}`;
        callApiindelay(url);
        setChangedSearchMode(false);
      }
    }
  }, [searchedBy]);
  //selectedState

  useEffect(() => {
    if (
      selectedState !== "" &&
      allPlans !== null &&
      Object.keys(allPlans).length > 0
    ) {
      const selectedPlanWithState = allPlans[selectedState];
      const allplanName = Object.keys(selectedPlanWithState);
      if (Array.isArray(allplanName)) {
        const totalPlanesNames = allplanName.map((val) => ({
          value: val,
          label: val,
        }));
        setAllAvailablePlaneOption(totalPlanesNames);
      }
    }
  }, [selectedState]);

  //selectedPlanes
  useEffect(() => {
    if (
      selectedState !== "" &&
      selectedPlanes !== "" &&
      allPlans !== null &&
      Object.keys(allPlans).length > 0
    ) {
      const selectedPlanWithStateandPlaneType =
        allPlans[selectedState][selectedPlanes];
      setRechargeTable(selectedPlanWithStateandPlaneType);
    }
  }, [selectedPlanes, allPlans, selectedState]);

  useEffect(() => {
    if (Array.isArray(selectedStatus) && selectedStatus.length > 0) {
      const values = selectedStatus.map((val) => val.value);
      setFinalSelectedStatus(values);
    } else if (Array.isArray(selectedStatus) && selectedStatus.length === 0) {
      setFinalSelectedStatus([]);
    }
  }, [selectedStatus]);
  useEffect(() => {
    if (selectOption === "All" && firstSelectedPage !== undefined) {
      setpageStart(1);
      setPagelimit(firstSelectedPage);
    } else if (
      selectOption == "Custom" &&
      firstSelectedPage !== undefined &&
      secondSelectedPage !== undefined
    ) {
      setpageStart(firstSelectedPage);
      setPagelimit(secondSelectedPage);
    }
  }, [selectOption, firstSelectedPage, secondSelectedPage]);
  //console.log("finalSelectedStatus", finalSelectedStatus);
  const Transactiontable = useSelector(
    (state) => state.transactionhistoryreducer.Transaction
  );
  const a = useSelector((state) => state.transactionhistoryreducer.Transaction);
  const responseobject = useSelector(
    (state) => state.getclaimdatareducer.getclaimdata
  );
  const url = `/api/v1/proxy/mobile/order/history/mis`;
  const finalSelectedtxnCat = undefined;
  const pageindexofStatus = 0;
  useEffect(() => {
    if (id && requesterId !== null && isUserAdmin(id)) {
      fetchpagedata(0, id, isUserAdmin(id), selectedId);
      // fetchStatus(0, id, isUserAdmin(id), selectedId);
      fetchStatus(
        pageindexofStatus,
        id,
        isUserAdmin(id),
        selectedId,
        setDataLoading,
        setsearch,
        axiosInstance,
        url,
        requesterId,
        uuid,
        formDate,
        currentDate,
        nextDate,
        toDate,
        finalSelectedStatus,
        setTransactionStatuswithAmount,
        setIsDataLoaded,
        toast,
        e,
        finalSelectedtxnCat
      );
    } else if (id && !isUserAdmin(id) && search.length == 0) {
      fetchpagedata(0, id, isUserAdmin(id), selectedId);
      // fetchStatus(0, id, isUserAdmin(id), selectedId);
      fetchStatus(
        pageindexofStatus,
        id,
        isUserAdmin(id),
        selectedId,
        setDataLoading,
        setsearch,
        axiosInstance,
        url,
        requesterId,
        uuid,
        formDate,
        currentDate,
        nextDate,
        toDate,
        finalSelectedStatus,
        setTransactionStatuswithAmount,
        setIsDataLoaded,
        toast,
        e,
        finalSelectedtxnCat
      );
    }
  }, [id, selectedId, requesterId]);

  const [pageindex, setpageindex] = useState("");
  // const setpageContent = (currentPage, finalLength, totalPost) =>{
  //   const firstIndex = currentPage == 1 ? 1 : currentPage * 20
  //   const finalIndex = currentPage == 1 ? 20 : firstIndex + finalLength
  //   return `Showing ${firstIndex} to ${finalIndex} of  ${totalPost}`
  // }

  const handalpageclick = async (index) => {
    setPaginationDetails((prev) => {
      return { ...prev, currentPage: index };
    });
    setpageindex(index);
    setpageindex((ind) => {
      return ind;
    });
    if (isUserAdmin(id) && selectedId !== null) {
      fetchpagedata(index - 1, id, isUserAdmin(id), selectedId);
    } else {
      fetchpagedata(index - 1, id, isUserAdmin(id));
    }
  };
  const totalpage = paginationDetails.totalPages;
  //console.log("paginationDetails", paginationDetails);
  const d =
    sessionStorage.getItem("token") &&
    JSON.parse(sessionStorage.getItem("token")).token
      ? JSON.parse(sessionStorage.getItem("token")).token
      : "";
  const e = JSON.parse(sessionStorage.getItem("token"));

  const searchdata = (event) => {
    if (searched.typingTimeout) {
      clearTimeout(searched.typingTimeout);
    }
    if (!searched.typing) {
      // setRetailerList([])
    }

    if (event.target.value !== "") {
      const trimSearch = event.target.value.trim();
      setSearched({
        name: trimSearch,
        typing: true,
        typingTimeout: setTimeout(function () {
          // sendToParent(searched.name);
          if (event.target.value) {
            setSearchTyping(true);
            setsearch(trimSearch);
          } else {
          }
        }, 500),
      });
    } else {
      setsearch(event.target.value);
      setSearched({
        typing: false,
      });
    }
  };
  const fetchpagedata = async (pageindex, id, isAdmin, selectedId) => {
    setDataLoading(true);
    setsearch("");
    const response = await axiosInstance
      .post(
        `/api/v1/proxy/mobile/order/history`,
        {
          header: {
            "client-id": id, // client id will admin id
            role: "ROLE_RETAILER_FINXPAY",
            msgType: "ORDER_HISTORY",
            channel: "ADMIN",
            requesterId: requesterId,
            requestId: uuid(),
            time: new Date(),
          },
          device: null,
          agentId: isAdmin ? selectedId : id,
          pageNo: pageindex,
          startDate: formDate,
          endDate: toDate,
          status:
            finalSelectedStatus !== undefined &&
            finalSelectedStatus.length !== 0
              ? finalSelectedStatus
              : null,
        },
        {
          headers: {
            Authorization: `Bearer ${e}`,
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
          },
        }
      )
      .then((res) => {
        //console.log("res", res);
        settable(res.data.orders);
        setBackupTableData(res.data);
        //return res
        setDataLoading(false);
        setIsDataLoaded(true);
        setPaginationDetails((prev) => {
          return {
            ...prev,
            totalPost: res.data?.totalElements,
            totalPages: res.data?.totalPages,
            currentPage: res.data.currentPage + 1,
          };
        });
      })
      .catch((err) => {
        //console.log(err);
        setDataLoading(false);
        setIsDataLoaded(false);
        toast.error("Something went wrong");
      });

    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };

  const searchapidata = async (id, url) => {
    setDataLoading(true);

    setSearchedByItemShow(false);
    const response = await axiosInstance
      .get(url, {
        headers: {
          Authorization: `Bearer ${e}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
        },
      })
      .then((res) => {
        setSearchedBy();
        setDataLoading(false);
        // setTimeout(() => {
        //   setSearchTyping(false)
        // }, 2500);
        setPaginationDetails((prev) => {
          return {
            ...prev,
            totalPost: 0,
            totalPages: 0,
          };
        });
        return res;
      })
      .catch((err) => {
        //console.log(err);
        setSearchedBy();
        setDataLoading(false);
        toast.error("Something went wrong");
      });
    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }

    return false;
  };
  // const exportToXLSX = (data) => {
  //   console.log('data', data)
  //   const worksheet = XLSX.utils.json_to_sheet(data);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  //   const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  //   const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  //   saveAs(blob, `${'aaaaa'}.xlsx`);
  // };
  const getCurrentDateTime = () => {
    const currentDate = new Date();
    const formattedDate = currentDate
      .toISOString()
      .slice(0, 10)
      .replace(/-/g, "");
    const formattedTime = currentDate
      .toTimeString()
      .slice(0, 8)
      .replace(/:/g, "");
    return `${formattedDate}_${formattedTime}`;
  };
  // const convertToXLSX = (data, fileName) => {
  //   const parsedData = Papa.parse(data, { header: true });
  //   const worksheet = XLSX.utils.json_to_sheet(parsedData.data);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  //   const excelBuffer = XLSX.write(workbook, {
  //     bookType: "xlsx",
  //     type: "array",
  //   });
  //   const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  //   saveAs(blob, `${fileName}.xlsx`);
  // };
  // const convertToXLSX = (data, fileName) => {
  //   const parsedData = Papa.parse(data, { header: true });

  //   const formattedData = parsedData.data.map((row) => ({
  //     ...row,
  //     Date: row.Date ? String(row.Date) : "", // 🔥 force string
  //   }));

  //   const worksheet = XLSX.utils.json_to_sheet(formattedData);
  //   const workbook = XLSX.utils.book_new();

  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  //   const excelBuffer = XLSX.write(workbook, {
  //     bookType: "xlsx",
  //     type: "array",
  //   });

  //   const blob = new Blob([excelBuffer], {
  //     type: "application/octet-stream",
  //   });

  //   saveAs(blob, `${fileName}.xlsx`);
  // };
  // const normalizeTimestamp = (value) => {
  //   if (!value) return "";

  //   const v = String(value).trim();

  //   // Strict ISO timestamp match
  //   const match = v.match(
  //     /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})(?:\.(\d{1,3}))?$/
  //   );

  //   if (!match) return v; // leave untouched if format is different

  //   const base = match[1]; // yyyy-MM-ddTHH:mm:ss
  //   const ms = (match[2] || "").padEnd(3, "0");

  //   return `${base}.${ms}`;
  // };
  const normalizeTimestamp = (value) => {
    if (!value) return "";

    const v = String(value).trim();

    const match = v.match(
      /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})(?:\.(\d{1,3}))?$/
    );

    if (!match) return v;

    const base = match[1];
    const ms = (match[2] || "").padEnd(3, "0");

    return `${base}.${ms}`;
  };
  const EXPECTED_DATE_REGEX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}$/;
  const getDateKey = (row) => Object.keys(row).find((k) => k.trim() === "Date");

  // const convertToXLSX = (data, fileName) => {
  //   const parsedData = Papa.parse(data, {
  //     header: true,
  //     skipEmptyLines: true,
  //   });

  //   const formattedData = parsedData.data.map((row) => ({
  //     ...row,
  //     Date: row.Date ? `'${normalizeTimestamp(row.Date)}` : "",
  //   }));

  //   const worksheet = XLSX.utils.json_to_sheet(formattedData, {
  //     cellDates: false,
  //   });

  //   // Force Date column as TEXT (Column K)
  //   Object.keys(worksheet).forEach((cell) => {
  //     if (cell.startsWith("K") && cell !== "K1") {
  //       worksheet[cell].t = "s";
  //       worksheet[cell].z = "@";
  //     }
  //   });

  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  //   const excelBuffer = XLSX.write(workbook, {
  //     bookType: "xlsx",
  //     type: "array",
  //   });

  //   const blob = new Blob([excelBuffer], {
  //     type: "application/octet-stream",
  //   });

  //   saveAs(blob, `${fileName}.xlsx`);
  // };
  const convertToXLSX = (data, fileName) => {
    const parsed = Papa.parse(data, {
      header: true,
      skipEmptyLines: true,
    });

    let fixedCount = 0;

    const formattedData = parsed.data.map((row, index) => {
      const dateKey = getDateKey(row);
      if (!dateKey || !row[dateKey]) return row;

      const original = String(row[dateKey]).trim();
      const normalized = normalizeTimestamp(original);

      if (original !== normalized) {
        fixedCount++;

        console.groupCollapsed(
          `%c[Date Fixed] Row ${index + 1}`,
          "color: orange; font-weight: bold"
        );
        console.log("Original :", original);
        console.log("Fixed    :", normalized);
        console.groupEnd();
      }

      return {
        ...row,

        [dateKey]: `${normalized}`, // Excel-safe
      };
    });

    console.info(
      `%cTotal Date values fixed: ${fixedCount}`,
      "color: green; font-weight: bold"
    );

    const worksheet = XLSX.utils.json_to_sheet(formattedData, {
      cellDates: false,
    });

    // 🔥 Force ONLY Date column to TEXT
    Object.keys(worksheet).forEach((cell) => {
      if (cell === "!ref") return;

      const cellAddress = XLSX.utils.decode_cell(cell);
      const headerCell = XLSX.utils.encode_cell({
        r: 0,
        c: cellAddress.c,
      });

      if (worksheet[headerCell]?.v?.trim() === "Date" && cellAddress.r !== 0) {
        worksheet[cell].t = "s";
        worksheet[cell].z = "@";
      }
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(blob, `${fileName}.xlsx`);
  };

  const fetchpagedataInloop = async (pageindex, id, isAdmin) => {
    setDataLoading(true);
    const response = await axiosInstance
      .post(
        `/api/v1/proxy/mobile/order/report`,
        {
          header: {
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
            msgType: "ORDER_HISTORY",
            channel: "ADMIN",
            requesterId: requesterId,
            time: new Date(),
          },
          device: null,
          agentId: isAdmin ? selectedId : id,
          pageNo: pageindex,
          startDate: formDate,
          endDate: toDate,
          status:
            finalSelectedStatus !== undefined &&
            finalSelectedStatus.length !== 0
              ? finalSelectedStatus
              : null,
        },
        {
          headers: {
            Authorization: `Bearer ${e}`,
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
            "Content-Disposition": "attachment;filename=report.xls",
            //  "Content-Type": "application/octet-stream"
          },
          // responseType: 'blob',
        }
      )
      .then((response) => {
        const fileName = `Mobile_Recharge_${getCurrentDateTime()}`;
        convertToXLSX(response?.data, fileName);
        setDataLoading(false);
      })
      .catch((err) => {
        //console.log(err);
        toast.error("Something went wrong");
        setDataLoading(false);
      });

    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    setDataLoading(false);
    return false;
  };
  const normalizeTimestampcsv = (value) => {
    if (!value) return value;

    // Match ISO timestamp with or without milliseconds
    const match = value.match(
      /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})(?:\.(\d{1,3}))?$/
    );

    if (!match) return value;

    const base = match[1];
    const ms = (match[2] || "").padEnd(3, "0");

    return `${base}.${ms}`;
  };

  const fetchpagedataInloopcsv = async (pageindex, id, isAdmin) => {
    setDataLoading(true);
    const response = await axiosInstance
      .post(
        `/api/v1/proxy/mobile/order/report`,
        {
          header: {
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
            msgType: "ORDER_HISTORY",
            channel: "ADMIN",
            requesterId: requesterId,
            time: new Date(),
          },
          device: null,
          agentId: isAdmin ? selectedId : id,
          pageNo: pageindex,
          startDate: formDate,
          endDate: toDate,
          status:
            finalSelectedStatus !== undefined &&
            finalSelectedStatus.length !== 0
              ? finalSelectedStatus
              : null,
        },
        {
          headers: {
            Authorization: `Bearer ${e}`,
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
            "Content-Disposition": "attachment;filename=report.xls",
            //  "Content-Type": "application/octet-stream"
          },
          // responseType: 'blob',
        }
      )
      .then((response) => {
        const fileName = `Mobile_Recharge_csv${getCurrentDateTime()}`;

        const parsed = Papa.parse(response.data, { header: true });

        const fixedRows = parsed.data.map((row) => ({
          ...row,
          Date: row.Date ? `'${normalizeTimestampcsv(String(row.Date))}` : "",
        }));

        const fixedCSV = Papa.unparse(fixedRows);

        const blob = new Blob([fixedCSV], {
          type: "text/csv;charset=utf-8;",
        });

        FileSaver.saveAs(blob, `${fileName}.csv`);
        setDataLoading(false);
      })

      .catch((err) => {
        //console.log(err);
        toast.error("Something went wrong");
        setDataLoading(false);
      });

    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    setDataLoading(false);
    return false;
  };
  const enterTxnsearch = (event) => {
    event.preventDefault();
    setsearch(event.target.value);
    setSearchTyping(true);
  };

  const onExportData = async () => {
    // setShowModel(true);
    const data = await fetchpagedataInloop(0, id, isUserAdmin(id));
  };

  const onExportDataCsv = async () => {
    // setShowModel(true);
    const data = await fetchpagedataInloopcsv(0, id, isUserAdmin(id));
  };

  const closePopUp = () => {
    setShowModel(false);
    setFirstSelectedPage();
    setSecondSelectedPage();
    setCustomPage("");
    setSelectOption("");
  };
  //console.log("formDate", formDate);
  async function exportAllFile() {
    const data = await fetchpagedataInloop(1, id, isUserAdmin(id));
  }
  const callApi = () => {
    if (isUserAdmin(id) && selectedId !== null) {
      fetchpagedata(0, id, isUserAdmin(id), selectedId);
      fetchStatus(
        pageindexofStatus,
        id,
        isUserAdmin(id),
        selectedId,
        setDataLoading,
        setsearch,
        axiosInstance,
        url,
        requesterId,
        uuid,
        formDate,
        currentDate,
        nextDate,
        toDate,
        finalSelectedStatus,
        setTransactionStatuswithAmount,
        setIsDataLoaded,
        toast,
        e,
        finalSelectedtxnCat
      );
    } else {
      fetchpagedata(0, id, isUserAdmin(id));
      fetchStatus(
        pageindexofStatus,
        id,
        isUserAdmin(id),
        selectedId,
        setDataLoading,
        setsearch,
        axiosInstance,
        url,
        requesterId,
        uuid,
        formDate,
        currentDate,
        nextDate,
        toDate,
        finalSelectedStatus,
        setTransactionStatuswithAmount,
        setIsDataLoaded,
        toast,
        e,
        finalSelectedtxnCat
      );
    }
  };
  const txnFromDateHandler = (e) => {
    setFormDate(e.target.value);
  };
  const txnToDateHandler = (e) => {
    setToDate(e.target.value);
  };
  const updatedFromDateHandler = (e) => {
    setUpdatedFormDate(e.target.value);
  };
  const updatedToDateHandler = (e) => {
    setUpdatedToDate(e.target.value);
  };
  const reverse = ["AUTO_REVERSED", "MANUALLY_REVERSED"];
  const callApiReversalRepoertApi = (e) => {
    e.preventDefault();
    setLoading(true);
    if (isUserAdmin(id) && selectedId !== null) {
      exportReversalReport(0, id, isUserAdmin(id), reverse);
    } else {
      exportReversalReport(0, id, isUserAdmin(id), reverse);
    }
  };
  async function exportReversalReport(
    pageindex,
    id,
    isAdmin,
    finalSelectedStatus
  ) {
    await axiosInstance
      .post(
        `/api/v1/billpay/order/history`,
        {
          header: {
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
            msgType: "ORDER_HISTORY",
            channel: "ADMIN",
            requesterId: requesterId,
            time: new Date(),
          },
          device: null,
          agentId: isAdmin ? selectedId : id,
          pageNo: pageindex,
          startDate: formDate,
          endDate: toDate,
          status:
            finalSelectedStatus !== undefined &&
            finalSelectedStatus.length !== 0
              ? finalSelectedStatus
              : null,
        },
        {
          headers: {
            Authorization: `Bearer ${e}`,
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
            msgType: isAdmin ? "ORDER_HISTORY" : "",
            channel: isAdmin ? "ADMIN" : "",
            requesterId: requesterId,
            time: new Date(),
          },
        }
      )
      .then((res) => {
        getExportFile(
          res.data?.totalPages !== undefined ? res.data?.totalPages : 0
        );
      })
      .catch((err) => {
        //console.log(err);
        toast.error("Something went wrong");
        setLoading(false);
      });
  }
  const getExportFile = async (allpagenum) => {
    let result = [];
    for (let i = 0; i < allpagenum; i++) {
      //console.log("index1", i);
      const data = await fetchpagedataInloop(i, id, isUserAdmin(id), reverse);
      if (Array.isArray(data?.orders)) {
        const unwantedHeaderForExcel = data.orders
          .filter((values) => {
            const updatedon = new Date(values.updatedOn);
            const newfromDate = new Date(updatedFormDate);
            const newToDate = new Date(updatedToDate);
            return updatedon > newfromDate && updatedon < newToDate;
          })
          .map((val) => {
            val.notes =
              val.notes !== null && val.notes !== undefined ? val.notes[0] : "";
            val.operator = val.transaction.operator;
            val.amount = val.transaction.amount;
            delete val.transaction;
            delete val.supplierId;
            delete val.statusChangeLog;
            delete val.supplierUrl;
            delete val.supplierOrderId;
            delete val.paymentRefId;

            delete val.paymentTxnId;
            delete val.paymentStatus;
            delete val.walletBalance;

            delete val.walletCreditLimit;
            delete val.walletLien;
            //  val={...val, ...val.optional}
            val.CONSUMER_NUM = val.optional.CONSUMER_NUM;
            val.category = val.optional.category;
            delete val.optional;
            const newvalues = val;
            return newvalues;
          });
        //console.log("unwantedHeaderForExcel", unwantedHeaderForExcel);
        result.push(...unwantedHeaderForExcel);
      }
    }

    // const csv = convertArrayToCSV(result);
    // const csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    // FileSaver.saveAs(csvData, "data.csv");
    // closePopUp();
    // setLoading(false);
  };

  const applyStatus = (e) => {
    e.preventDefault();
    setIsExportable(true);
    callApi();
  };
  useEffect(() => {
    if (
      finalSelectedStatus !== undefined &&
      finalSelectedStatus.length == 0 &&
      isclearClicked
    ) {
      callApi();
    }
  }, [finalSelectedStatus]);
  const resetApply = () => {
    setFinalSelectedStatus([]);
    setSelectedStatus([]);
    setIsExportable(false);
    setFormDate("");
    setToDate("");
    setIsclearClicked(true);
  };
  const fromDateHandler = (e) => {
    setFormDate(e.target.value);
  };
  const toDateHandler = (e) => {
    setToDate(e.target.value);
  };
  const changeHandler = (select) => {
    setSelectedStatus(select);
  };
  const revcheckDisable = () => {
    let disabled = true;
    if (
      formDate !== "" &&
      toDate !== "" &&
      updatedFormDate !== "" &&
      updatedToDate !== ""
    ) {
      disabled = false;
    }
    return disabled;
  };
  const checkDisable = () => {
    let disabled = true;
    if (finalSelectedStatus !== undefined && finalSelectedStatus.length > 0) {
      disabled = false;
    } else if (formDate !== "") {
      disabled = false;
    } else if (toDate !== "") {
      disabled = false;
    }
    return disabled;
  };
  const refundPage = () => {
    navigate("/refund-status");
  };
  const handleChangeCategoryCode = (newValue, actionMeta) => {
    console.groupEnd();
  };
  //handleChangeOperator
  //handleChangePlanType
  const handleChangePlanType = (newValue, actionMeta) => {
    let values = newValue?.value;
    if (newValue?.__isNew__ !== undefined && newValue?.__isNew__) {
      setIsNewProductAdded(true);

      const newValues = { label: newValue.label, value: newValue?.value };
      setAllAvailablePlaneOption([...allAvailablePlaneOption, newValues]);
      setProductDetails((val) => {
        return { ...val, planType: values };
      });
      setRechargeTable([]);
    } else {
      setSelectedPlanes(values);
      setProductDetails((val) => {
        return { ...val, planType: values };
      });
    }

    console.groupEnd();
  };
  const handleChangeOperator = (newValue, actionMeta) => {
    let values = newValue?.value;
    setSelectedOperator(values);
    setProductDetails((val) => {
      return { ...val, operator: values };
    });
    console.groupEnd();
  };
  //handleChangeStates

  const handleChangeStates = (newValue, actionMeta) => {
    // console.log("aaa", newValue);
    let values = newValue?.value;
    setSelectedSatate(values);
    setProductDetails((val) => {
      return { ...val, circle: values };
    });
    console.groupEnd();
  };
  const handleInputChange = (inputValue, actionMeta) => {
    console.groupEnd();
  };
  const addSlab = () => {
    setProductDetails({
      ...productDetails,
      plans: [
        ...productDetails.plans,
        {
          rs: "",
          desc: "",
          validity: "",
          last_update: getDateAndTime(),
        },
      ],
    });
  };

  const removeSlab = (index) => {
    let tempSlab = [...productDetails.plans];
    var filtered =
      tempSlab !== undefined &&
      tempSlab.filter(function (value, ind) {
        return ind !== index;
      });

    setProductDetails({
      ...productDetails,
      plans: [...filtered],
    });
  };
  const productHandle = (e, index) => {
    let { name, value } = e.target;

    let tempSlab = [...productDetails.plans];
    tempSlab[index][name] = value;
    setProductDetails({
      ...productDetails,
      plans: [...tempSlab],
    });
  };
  //editPlans
  const editPlans = (data) => {
    setSelectedEditPlan(data.rs);
    setIsNewProductAdded(true);

    setProductDetails((val) => {
      return { ...val, plans: [{ ...data }] };
    });
  };

  const salesDetails = () => {
    const slots = "price";

    return (
      productDetails?.plans !== undefined &&
      Array.isArray(productDetails?.plans) &&
      productDetails.plans.map((val, ind, self) => {
        return (
          <div class="newpricelist">
            <div class="pricbtn" id={`prcslb${ind + 3}${slots}`}>
              {ind !== 4 && ind + 1 == self.length && (
                <button
                  type="button"
                  class="add-slab"
                  data-toggle="tooltip"
                  title="Add Slab"
                  onClick={() => addSlab(ind)}
                ></button>
              )}
              {self.length !== 1 &&
              self.length == ind + 1 &&
              self.length < 5 ? (
                <button
                  type="button"
                  class="remove-slab"
                  data-toggle="tooltip"
                  title="Remove Slab"
                  onClick={() => removeSlab(ind)}
                ></button>
              ) : ind == 0 && self.length == 1 ? (
                ""
              ) : (
                <button
                  type="button"
                  class="remove-slab-one"
                  data-toggle="tooltip"
                  title="Remove Slab"
                  onClick={() => removeSlab(ind)}
                ></button>
              )}
              <button
                type="button"
                class="collapsed"
                data-bs-toggle="collapse"
                data-bs-target={`#slab${ind + 3}${slots}`}
                aria-expanded="true"
                aria-controls={`slab${ind + 3}${slots}`}
              >
                {`Custom Plan ${ind + 1}`}
              </button>
            </div>

            <div
              id={`slab${ind + 3}${slots}`}
              class="collapse"
              aria-labelledby={`prcslb${ind + 3}${slots}`}
              data-bs-parent="#pricesale"
            >
              <div class="slabox">
                <div class="row">
                  <div class="col-12">
                    <div class="prinput">
                      <div class="row">
                        {
                          <>
                            <div class="col-6 col-sm-6">
                              <div class="input-group">
                                <span class="input-group-text">Price</span>
                                <input
                                  type="number"
                                  min={0}
                                  class="form-control form-control-sm"
                                  placeholder="Enter Number"
                                  // disabled={isFixedSelected}
                                  onWheel={(event) =>
                                    event.currentTarget.blur()
                                  }
                                  onChange={(e) => productHandle(e, ind)}
                                  name="rs"
                                  value={productDetails.plans[ind].rs}
                                />
                              </div>
                            </div>

                            <div class="col-6 col-sm-6">
                              <div class="input-group">
                                <span class="input-group-text">validity</span>
                                <input
                                  type="number"
                                  min={0}
                                  class="form-control form-control-sm"
                                  placeholder="Enter Number"
                                  onChange={(e) => productHandle(e, ind)}
                                  name="validity"
                                  onWheel={(event) =>
                                    event.currentTarget.blur()
                                  }
                                  value={productDetails.plans[ind].validity}
                                />
                              </div>
                            </div>
                            <div class="col-6 col-sm-12 mt-2 ">
                              <div class="input-group">
                                <span class="input-group-text">Desc</span>
                                <input
                                  type="text"
                                  //  min={0}
                                  class="form-control form-control-sm"
                                  placeholder="Enter Desc"
                                  onChange={(e) => productHandle(e, ind)}
                                  name="desc"
                                  onWheel={(event) =>
                                    event.currentTarget.blur()
                                  }
                                  value={productDetails.plans[ind].desc}
                                />
                              </div>
                            </div>
                          </>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
    );
  };
  const onsavePlan = async () => {
    // setIsDataRechargeLoaded(true);
    // setsearch("");

    const filterCustomPlan = rechargeTable.filter(
      (val) => val.custom && val.rs !== selectedEditPlan
    );

    const fullPlan =
      filterCustomPlan.length > 0
        ? [...filterCustomPlan, ...productDetails.plans]
        : productDetails.plans;
    const planwithPayload = { ...productDetails, plans: fullPlan };

    const response = await axiosInstance
      .post(
        `/api/v1/catalog/mobile/add-plan`,
        {
          ...planwithPayload,
        },
        {
          headers: {
            Authorization: `Bearer ${e}`,
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
          },
        }
      )
      .then((res) => {
        setIsNewProductAdded(false);
        setSelectedEditPlan("");
        getPlans();
        setProductDetails({
          ...productDetails,
          plans: [
            {
              rs: "",
              desc: "",
              validity: "",
              last_update: getDateAndTime(),
            },
          ],
        });
      })
      .catch((err) => {
        setIsDataRechargeLoaded(false);
      });
  };
  const showAllData = (data) => {
    setSelectedDataToShow({ ...data });
    setShowModelDetails(true);
  };
  const closeDetailsPopUp = () => {
    setShowModelDetails(false);
  };
  const checkAddReachargeDisable = () => {
    let disable = true;
    if (
      selectedOperator !== "" &&
      selectedState !== "" &&
      selectedPlanes !== ""
    ) {
      disable = false;
    }
    return disable;
  };
  const clearSearchData = () => {
    setsearch("");
    setSearched({ name: "", typing: false, typingTimeout: 0 });
    //console.log("res", res);
    settable(
      backupTableData?.orders !== undefined && backupTableData?.orders !== null
        ? backupTableData?.orders
        : []
    );

    //return res
    setDataLoading(false);
    setIsDataLoaded(true);
    setPaginationDetails((prev) => {
      return {
        ...prev,
        totalPost:
          backupTableData?.totalElements !== undefined &&
          backupTableData?.totalElements,
        totalPages:
          backupTableData?.totalPages !== undefined &&
          backupTableData?.totalPages,
        currentPage:
          backupTableData?.currentPage !== undefined
            ? backupTableData?.currentPage + 1
            : 1,
      };
    });
  };
  const checkAddPlanDisable = () => {
    let disable = true;
    if (
      productDetails.plans[0].rs !== "" &&
      productDetails.plans[0].validity !== "" &&
      productDetails.plans[0].desc !== ""
    ) {
      disable = false;
    }
    return disable;
  };
  // const percentage = 66;
  const initialValue = 0;
  const sumOfallSatus = transactionStatuswithAmount.reduce(
    (accumulator, currentValue) => accumulator + currentValue?.count,
    initialValue
  );
  // console.log("sumOfallSatus", sumOfallSatus);
  return (
    <React.Fragment>
      {loading ? (
        requestLoading()
      ) : (
        <>
          <AskpageNumber
            showModal={showModal}
            closePopUp={closePopUp}
            totalpage={totalpage}
            setFirstSelectedPage={setFirstSelectedPage}
            firstSelectedPage={firstSelectedPage}
            exportAllFile={exportAllFile}
            secondSelectedPage={secondSelectedPage}
            setSecondSelectedPage={setSecondSelectedPage}
            selectOption={selectOption}
            setSelectOption={setSelectOption}
            customPage={customPage}
            setCustomPage={setCustomPage}
          />
          <ShowAllDetails
            showModal={showModalDetails}
            closePopUp={closeDetailsPopUp}
            data={selectedDataToShow}
          />
          <div class="mid">
            <div class="container-fluid">
              <div class="maincard">
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                  <button
                    class="nav-link active"
                    id="mobile-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-mobi"
                    type="button"
                    role="tab"
                    aria-controls="nav-mobi"
                    aria-selected="true"
                  >
                    Mobile Recharge Txn
                  </button>
                  {(isSuperAdmin(id) || isUserAdmin(id)) && (
                    <button
                      class="nav-link"
                      id="mobi-grap-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#mobi-grap"
                      type="button"
                      role="tab"
                      aria-controls="mobi-grap"
                      aria-selected="false"
                    >
                      Recharge Plans
                    </button>
                  )}
                </div>

                <div class="tab-content" id="mobiletab">
                  <div
                    class="tab-pane fade show active"
                    id="nav-mobi"
                    role="tabpanel"
                    aria-labelledby="mobile-tab"
                  >
                    <div style={{ marginTop: "0px" }} class="head">
                      {/* <h3>Recharge History</h3> */}
                      {/* <div style={{display: 'block'}}> */}

                      <div style={{ marginTop: "20px" }} class="dropdown fltr">
                        <button
                          type="button"
                          title="Filter"
                          class="filter dropdown-toggle"
                          id="fillist"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="false"
                          aria-expanded="false"
                          // style={{border:'2px solid rgb(132, 133, 135)'}}
                        >
                          Filter
                        </button>
                        <div
                          class="dropdown-menu dropdown-menu-end"
                          aria-labelledby="fillist"
                        >
                          <form onSubmit={applyStatus}>
                            <div className="col-12 col-md-12 mb-2 border-bottom ">
                              <div class="form-floating">
                                <div className="formselect mb-2">
                                  <label>Selected Status</label>
                                  <Select
                                    className="basic-multi-select"
                                    styles={stylesofStype}
                                    closeMenuOnSelect={false}
                                    components={{
                                      IndicatorsContainer: () => null,
                                      IndicatorSeparator: () => null,
                                    }}
                                    isMulti
                                    options={statusOption}
                                    onChange={changeHandler}
                                    value={selectedStatus}
                                    placeholder=" select multiple option"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="filters">
                              <label for="select-state">From Date:</label>
                              <input
                                type="date"
                                onChange={fromDateHandler}
                                value={formDate}
                              />
                            </div>

                            <div class="filters">
                              <label for="select-state">To Date:</label>
                              <input
                                min={formDate}
                                type="date"
                                onChange={toDateHandler}
                                value={toDate}
                              />
                            </div>

                            <div class="fbtn">
                              <button
                                class="btn"
                                type="submit"
                                id="btna"
                                disabled={checkDisable()}
                              >
                                Apply
                              </button>
                              <button
                                class="btn"
                                type="reset"
                                id="btnc"
                                onClick={resetApply}
                              >
                                Clear
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                      {/* <div class="headsearch"> */}

                      <div
                        style={{
                          backgroundColor: "#9FA6B2",
                          marginTop: "20px",
                        }}
                        class="search allsearch"
                      >
                        <form autocomplete="off" action="#">
                          <div class="autocomplete">
                            <input
                              id="myInput"
                              type="text"
                              name=""
                              style={{ backgroundColor: "#9FA6B2" }}
                              placeholder="Search"
                              value={searched?.name}
                              onChange={searchdata}
                            />
                            <button
                              type="button"
                              onClick={clearSearchData}
                              style={{
                                position: "absolute",
                                backgroundColor: "#848587",
                              }}
                              className="search-btn"
                            ></button>
                            {search !== undefined &&
                              search !== null &&
                              searchedByItemShow &&
                              search.length > 2 &&
                              searchTyping && (
                                <div
                                  id="myInputautocomplete-list"
                                  class="autocomplete-items"
                                  style={{
                                    marginTop: "3px",
                                    borderTopLeftRadius: "7px",
                                  }}
                                >
                                  <button
                                    style={{
                                      background: "#9FA6B2",
                                      width: "30px",
                                      height: "30px",
                                      fontSize: "20px",
                                      borderRadius: "20px",
                                      opacity: 1,
                                    }}
                                    type="button"
                                    class="close"
                                    aria-label="Close"
                                    onClick={() => setSearchTyping(false)}
                                  >
                                    <span aria-hidden="true">&times;</span>
                                  </button>
                                  {search !== undefined &&
                                    search !== null &&
                                    search.length > 2 &&
                                    searchedByItem.map((val, index) => {
                                      return (
                                        <div
                                          key={index}
                                          onClick={() => {
                                            setSearchedBy(val);
                                            setSearchedByItemShow(true);
                                          }}
                                          style={{
                                            backgroundColor: `${
                                              searchedBy == val
                                                ? "#d0d2d6"
                                                : "#fff"
                                            }`,
                                          }}
                                        >
                                          {val}
                                          <input
                                            type="hidden"
                                            value="Denmark"
                                          />
                                        </div>
                                      );
                                    })}
                                </div>
                              )}
                          </div>
                        </form>
                      </div>

                      <div
                        style={{ marginTop: "20px" }}
                        class="dropdown fltr mr-1 reversal"
                      >
                        <button
                          type="button"
                          title="Revesal Report"
                          class="filter dropdown-toggle"
                          id="fillist"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="false"
                          aria-expanded="false"
                          style={{ border: "2px solid rgb(14 14 14)" }}
                        >
                          Revesal Report
                        </button>
                        <div
                          class="dropdown-menu dropdown-menu-end"
                          id="filterbox"
                          aria-labelledby="fillist"
                        >
                          <form onSubmit={callApiReversalRepoertApi}>
                            <div class="filters">
                              <label for="select-state">TXN From Date:</label>
                              <input
                                type="date"
                                onChange={txnFromDateHandler}
                                value={formDate}
                              />
                            </div>

                            <div class="filters">
                              <label for="select-state">TXN To Date:</label>
                              <input
                                min={formDate}
                                type="date"
                                onChange={txnToDateHandler}
                                value={toDate}
                              />
                            </div>
                            <div class="filters">
                              <label for="select-state">
                                Updated From Date:
                              </label>
                              <input
                                type="date"
                                onChange={updatedFromDateHandler}
                                value={updatedFormDate}
                              />
                            </div>

                            <div class="filters">
                              <label for="select-state">Updated To Date:</label>
                              <input
                                min={formDate}
                                type="date"
                                onChange={updatedToDateHandler}
                                value={updatedToDate}
                              />
                            </div>
                            <div class="fbtn">
                              <button
                                class="btn"
                                id="btnapply"
                                disabled={revcheckDisable()}
                                type="submit"
                              >
                                Download Reversal Report
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>

                      {/* </div> */}
                      {isSuperAdmin(id) && isUserAdmin(id) && (
                        <button
                          onClick={refundPage}
                          title="Refund"
                          style={{
                            marginRight: "5px",
                            marginTop: "2px",
                            marginTop: "20px",
                          }}
                        >
                          {ruppysymble} <i class="bi bi-forward-fill"></i>
                        </button>
                      )}

                      {/* <button style={{ marginTop: "2px" }}>
                        {" "}
                        <i
                          style={{ cursor: "pointer", fontSize: "15px" }}
                          onClick={() => {
                            callApi();
                          }}
                          class="bi bi-arrow-clockwise"
                        ></i>
                      </button> */}

                      {/* </div> */}
                      {/* <div style={{
                          
                           fontSize:'35px',
                           fontWeight:'bold',
                           color:'rgb(159, 166, 178)',
                           
                           }}>
                            <i style={{cursor:'pointer'}}  onClick={()=>{callApi()}} class="bi bi-arrow-clockwise"></i>
                           </div> */}

                      {/* <div className="whole">
                          {
                            transactionStatuswithAmount !== null && transactionStatuswithAmount !== undefined && transactionStatuswithAmount.length > 0  &&
                            transactionStatuswithAmount.map((txnstatus, inde)=>{
              
                              if(txnstatus.id == "SUCCESS"){
                             
                                return <span key={inde} class="badge badge-pill bg-success mr-1">{txnstatus?.id}, {txnstatus?.count}, {`${ruppysymble}${txnstatus?.total}`}</span>
                              } else if(txnstatus?.id == "FAILED"){
                              
                               return <span key={inde} class="badge badge-pill bg-danger mr-1">{txnstatus?.id}, {txnstatus?.count}, {`${ruppysymble}${txnstatus?.total}`}</span>
                              } else if(txnstatus?.id == "PENDING"){
                                
                              return  <span key={inde} class="badge badge-pill bg-warning mr-1">{txnstatus?.id}, {txnstatus?.count},{`${ruppysymble}${txnstatus?.total}`}</span>
                              }
                            })
                          }
                           </div> */}
                      <StatusDetails
                        transactionStatuswithAmount={
                          transactionStatuswithAmount
                        }
                        sumOfallSatus={sumOfallSatus}
                      />
                    </div>
                    <div class="txn-list" id="recntxn">
                      {dataLoading ? (
                        <div class="d-flex justify-content-center">
                          <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <>
                          {table !== undefined &&
                          table !== null &&
                          isDataLoaded &&
                          table.length == 0 ? (
                            <h6>No Record Found</h6>
                          ) : table !== undefined &&
                            table == null &&
                            isDataLoaded ? (
                            <h6>No Record Found</h6>
                          ) : (
                            table?.map((data) => {
                              return (
                                <div class="txn-item" key={data.id}>
                                  <div class="txn-head" id="txnhead1">
                                    <div
                                      class="collapsed"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#txn1"
                                      aria-expanded="false"
                                      aria-controls="txn1"
                                    >
                                      <div
                                        class={`txncard ${
                                          data.status === "SUCCESS"
                                            ? "success grbg"
                                            : `${
                                                data.status === "PENDING" ||
                                                data.status === "PROCESSING" ||
                                                data.status === "HUNG" ||
                                                data.status === "ACCEPTED"
                                                  ? "pending ylbg"
                                                  : "failed rdbg"
                                              }`
                                        }`}
                                      >
                                        <div class="row">
                                          <div
                                            class={`col-12 ${
                                              (isSuperAdmin(id) &&
                                                selectedId == null) ||
                                              (isUserAdmin(id) &&
                                                selectedId == null)
                                                ? "col-md-3"
                                                : "col-md-4"
                                            }`}
                                          >
                                            <div class="txntxt">
                                              {/* <li className="bill"> */}
                                              {/* <img src={require('../../assests/images/airtel.png')} alt="logo"/> */}
                                              <h5>
                                                {data.transaction.operator} -{" "}
                                                {data.transaction.mobile}
                                              </h5>
                                              {/* </li> */}
                                            </div>
                                            <div class="txntxt">
                                              <h6>TxnID: {data?.id}</h6>
                                            </div>
                                          </div>
                                          {/* <div class="col-12 col-sm-5 col-lg-3">
                                  <div class="txntxt">
                                    <h6>Txn ID: {data.requestId}</h6>
                                  </div>
                                </div> */}

                                          <div
                                            // class="col-12 col-md-3"
                                            class={`col-12 ${
                                              isSuperAdmin(id)
                                                ? "col-md-3"
                                                : isUserAdmin(id)
                                                ? "col-md-4"
                                                : "col-md-3"
                                            }`}
                                          >
                                            <div class="txntxt">
                                              <h6>
                                                BilltxID: {data.billerTxnId}
                                              </h6>
                                              {(isSuperAdmin(id) &&
                                                selectedId == null) ||
                                              (isUserAdmin(id) &&
                                                selectedId == null) ? (
                                                <h6>
                                                  Req ID: {data?.requestId}
                                                </h6>
                                              ) : (
                                                <h6>
                                                  <span>
                                                    {" "}
                                                    {data?.createdOn
                                                      .replace("T", " ")
                                                      .slice(0, -4)}{" "}
                                                  </span>{" "}
                                                </h6>
                                              )}
                                            </div>
                                          </div>
                                          <div class="col-12 col-md-2">
                                            <div class="txntxt">
                                              <h4>
                                                ₹ {data.transaction.amount}{" "}
                                              </h4>
                                              <h4>
                                                {" "}
                                                <span
                                                  class={`${
                                                    data.status === "SUCCESS"
                                                      ? "success"
                                                      : `${
                                                          data.status ===
                                                            "PENDING" ||
                                                          data.status ===
                                                            "PROCESSING" ||
                                                          data.status ===
                                                            "HUNG" ||
                                                          data.status ===
                                                            "ACCEPTED"
                                                            ? "pending"
                                                            : "failed"
                                                        }`
                                                  }`}
                                                >
                                                  {data.status}
                                                </span>
                                              </h4>
                                            </div>
                                          </div>
                                          <div class="col-12 col-md-2">
                                            <div class="txntxt">
                                              {((isSuperAdmin(id) &&
                                                selectedId == null) ||
                                                (isUserAdmin(id) &&
                                                  selectedId == null)) && (
                                                <h6>
                                                  AgentId: {data?.agentId}
                                                </h6>
                                              )}
                                              {((isSuperAdmin(id) &&
                                                selectedId == null) ||
                                                (isUserAdmin(id) &&
                                                  selectedId == null)) && (
                                                <h6>
                                                  <span>
                                                    {" "}
                                                    {data?.createdOn !==
                                                      undefined &&
                                                      data?.createdOn !==
                                                        null &&
                                                      data?.createdOn
                                                        .replace("T", " ")
                                                        .slice(0, -4)}{" "}
                                                  </span>{" "}
                                                </h6>
                                              )}
                                            </div>
                                          </div>
                                          <div
                                            class={`col-12  ${
                                              (isSuperAdmin(id) &&
                                                selectedId == null) ||
                                              (isUserAdmin(id) &&
                                                selectedId == null)
                                                ? "col-md-2"
                                                : "col-md-1"
                                            } float-right`}
                                          >
                                            <div class="txntxt">
                                              {isSuperAdmin(id) && (
                                                <button
                                                  type="button"
                                                  style={{
                                                    float: "right",
                                                    backgroundColor:
                                                      "rgb(159, 166, 178)",
                                                  }}
                                                  className="btn dbbtn"
                                                  onClick={() =>
                                                    showAllData(data)
                                                  }
                                                >
                                                  <i class="bi bi-eye-fill"></i>{" "}
                                                  Logs
                                                </button>
                                              )}
                                              {/* {((isSuperAdmin(id) &&
                                                selectedId == null) ||
                                                (isUserAdmin(id) &&
                                                  selectedId == null)) && (
                                                <h6 style={{ float: "right"  }}>
                                                  <span>
                                                    {" "}
                                                    {data.createdOn
                                                      .replace("T", " ")
                                                      .slice(0, -4)}{" "}
                                                  </span>{" "}
                                                </h6>
                                              )} */}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          )}

                          <div class="pager">
                            {table !== undefined &&
                              table !== null &&
                              table.length > 0 &&
                              search == "" && (
                                <p>
                                  {paginationDetails.currentPage !==
                                    undefined &&
                                    paginationDetails.currentPage !== null &&
                                    paginationDetails.totalPost !== undefined &&
                                    paginationDetails.totalPost !== null &&
                                    table !== undefined &&
                                    Array.isArray(table) &&
                                    setpageContent(
                                      paginationDetails.currentPage - 1,
                                      table.length,
                                      paginationDetails.totalPost
                                    )}
                                  <button
                                    class={
                                      isExportable
                                        ? "lbbtn"
                                        : "lbbtn-disable-btn"
                                    }
                                    disabled={!isExportable}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="First select the filter than you can export"
                                    type="button"
                                    onClick={onExportData}
                                  >
                                    Export xlsx
                                  </button>
                                  <button
                                    class={
                                      isExportable
                                        ? "lbbtn"
                                        : "lbbtn-disable-btn"
                                    }
                                    disabled={!isExportable}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="First select the filter than you can export"
                                    type="button"
                                    onClick={onExportDataCsv}
                                  >
                                    Export csv
                                  </button>
                                </p>
                              )}

                            {
                              paginationDetails.totalPost !== undefined &&
                                paginationDetails.totalPost !== null &&
                                paginationDetails.totalPost > 10 &&
                                search == "" && (
                                  <Pagination
                                    className="pagination-bar"
                                    currentPage={paginationDetails.currentPage}
                                    totalCount={paginationDetails.totalPost}
                                    pageSize={paginationDetails.postsPerPage}
                                    onPageChange={(page) =>
                                      handalpageclick(page)
                                    }
                                  />
                                )
                              // <Pagination  postsPerPage={paginationDetails.postsPerPage} totalPosts={table.length} paginate={paginate} currentPage={paginationDetails.currentPage} />
                            }
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <AllRechagePlan
                    handleChangeOperator={handleChangeOperator}
                    handleInputChange={handleInputChange}
                    allOperatorList={allOperatorList}
                    stylesofStypeNew={stylesofStypeNew}
                    handleChangeStates={handleChangeStates}
                    states={states}
                    isDataRechargeLoaded={isDataRechargeLoaded}
                    allAvailablePlaneOption={allAvailablePlaneOption}
                    checkAddReachargeDisable={checkAddReachargeDisable}
                    handleChangePlanType={handleChangePlanType}
                    setIsNewProductAdded={setIsNewProductAdded}
                    rechargeTable={rechargeTable}
                    isnewProductAdded={isnewProductAdded}
                    editPlans={editPlans}
                    salesDetails={salesDetails}
                    onsavePlan={onsavePlan}
                    checkAddPlanDisable={checkAddPlanDisable}
                  />
                  {/* <div
                    class="tab-pane fade"
                    id="mobi-grap"
                    role="tabpanel"
                    aria-labelledby="mobi-grap-tab"
                  >
                   <TransactionGraph/> 
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

export default MobileRecharge;
